// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .PasswordVerification-root-O9FHs {
 	padding-left: 20px;
 	padding-right: 20px;
 }

 .PasswordVerification-container-njMG4 {
 	margin: 0 auto;
 	padding: 73px 0px 40px;
 	max-width: 426px;
 }`, "",{"version":3,"sources":["webpack://./src/routes/passwordVerification/PasswordVerification.css"],"names":[],"mappings":"CAAC;EACC,kBAAkB;EAClB,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,sBAAsB;EACtB,gBAAgB;CACjB","sourcesContent":[" .root {\n \tpadding-left: 20px;\n \tpadding-right: 20px;\n }\n\n .container {\n \tmargin: 0 auto;\n \tpadding: 73px 0px 40px;\n \tmax-width: 426px;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `PasswordVerification-root-O9FHs`,
	"container": `PasswordVerification-container-njMG4`
};
module.exports = ___CSS_LOADER_EXPORT___;
